/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-fund-by-broker',
  template: require('./fund-by-broker.component.html')
})

export class FundByBrokerComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.isStreamline = this.appActions.getData('Streamline');
  }

  updateOptionValue(event) {
    if (event.id === 'acats_amount') {
      if (event.value === 'PARTIAL_TRANSFER') {
        this.form.inputs['manualDocumentation'].showUp = true;
        this.form.buttons.inputs.next.classes = 'hide';
        this.form.buttons.inputs.back.classes = 'btn-secondary no-margin-left';
      } else if (event.value === 'FULL_TRANSFER') {
        this.form.inputs['manualDocumentation'].showUp = false;
        this.form.buttons.inputs.next.classes = 'btn mobile-primary';
        this.form.buttons.inputs.back.classes = 'btn-flat';
      }
    }
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  btnClick(e) {
    if (e.action === 'next') {
      this.router.navigate(['/fund-by-broker-choose-firm']);
    } else if (e.action === 'back') {
      if (this.isStreamline === true) {
        this.router.navigate(['/funding-choices-streamline']);
      } else {
        this.appActions.deleteData('Acats');
        this.router.navigate(['/funding-choices']);
      }
    } else if (e.action === 'fund_later') {
      this.flowManager.fundLaterRouting();
    }
  }
}
